export const asyncTimeout = (ms: number) => {
  return new Promise<void>((resolve) => {
    return setTimeout(resolve, ms);
  });
};
